import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  maintenanceTickets: [],
  currentMaintenanceTicket: null,
}

const maintenanceTicketSlice = createSlice({
  name: 'maintenanceTicketList',
  initialState,
  reducers: {
    setMaintenanceTickets: (state, action) => {
      state.maintenanceTickets = action.payload.maintenanceTickets;
    },
    createMaintenanceTicket: (state, action) => {
      const newMaintenanceTicket = action.payload;
      const existingMaintenanceTicket = state.maintenanceTickets.find(maintenanceTicket => maintenanceTicket.id === newMaintenanceTicket.id);
      if (!existingMaintenanceTicket) {
        state.maintenanceTickets.push(newMaintenanceTicket);
      }
    },
    addMaintenanceTickets: (state, action) => {
      const newMaintenanceTickets = action.payload.maintenanceTickets?.filter(newMaintenanceTicket => 
        !state.maintenanceTickets?.some(existingMaintenanceTicket => existingMaintenanceTicket.id === newMaintenanceTicket.id)
      );
      state.maintenanceTickets?.push(...newMaintenanceTickets);
    },
    saveMaintenanceTicket: (state, action) => {
      const maintenanceTicketIndex = state.maintenanceTickets.findIndex(mt => mt.id === action.payload.maintenanceTicket?.id)
      if (maintenanceTicketIndex !== -1) {
        state.maintenanceTickets[maintenanceTicketIndex] = {
          ...state.maintenanceTickets[maintenanceTicketIndex],
          ...action.payload.maintenanceTicket
        }
      }
      if (state.currentMaintenanceTicket?.id === action.payload.maintenanceTicket?.id) {
        state.currentMaintenanceTicket = state.maintenanceTickets[maintenanceTicketIndex]
      }
    },
    updateMaintenanceTicket: (state, action) => {
      const maintenanceTicketIndex = state.maintenanceTickets.findIndex(mt => mt.id === action.payload.id)
      if (maintenanceTicketIndex !== -1) {
        state.maintenanceTickets[maintenanceTicketIndex] = { ...action.payload }; // Ensures new reference
      }
      state.currentMaintenanceTicket = { ...action.payload }; // Ensures new reference
    },
    deleteMaintenanceTicket: (state, action) => {
      const maintenanceTicketIndex = state.maintenanceTickets.findIndex(mt => mt.id === action.payload)
      if (maintenanceTicketIndex !== -1) {
        state.maintenanceTickets.splice(maintenanceTicketIndex, 1)
      }
    },
    setCurrentMaintenanceTicket: (state, action) => {
      state.currentMaintenanceTicket = state.maintenanceTickets.find(mt => mt.id === action.payload) || null
    },
    syncMaintenanceTicketsFromDB: (state, action) => {
      const dbMaintenanceTickets = action.payload.maintenanceTickets || [];
      dbMaintenanceTickets.forEach(dbMaintenanceTicket => {
        const existingIndex = state.maintenanceTickets.findIndex(mt => mt.id === dbMaintenanceTicket.id);
        if (existingIndex !== -1) {
          // Update existing task
          state.maintenanceTickets[existingIndex] = {
            ...state.maintenanceTickets[existingIndex],
            ...dbMaintenanceTicket
          };
        } else {
          // Add new task
          state.maintenanceTickets.push(dbMaintenanceTicket);
        }
      });
    },
  },
})

export const { 
  setMaintenanceTickets,
  createMaintenanceTicket,
  addMaintenanceTickets,
  saveMaintenanceTicket,
  updateMaintenanceTicket,
  deleteMaintenanceTicket,
  setCurrentMaintenanceTicket,
  syncMaintenanceTicketsFromDB,
} = maintenanceTicketSlice.actions

export default maintenanceTicketSlice.reducer;
